
import Vue from 'vue'
import { Dropdown, Btn } from 'uiv'

export default Vue.extend({
   name: 'CogMenuComponent',
   props: { right: { type: Boolean, default: true } },
   components: {
      Btn,
      Dropdown,
   },
})
